import { UCD } from "./UCD.js";
import { validateTidalLicense } from "../../../base/index.js";
validateTidalLicense();
export {
  UCD
};
//# sourceMappingURL=index.js.map
